import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PageHeader, useToast } from 'components/admin';
import { Button, Checkbox, Input } from 'components/common';
import { createIntroduceMenu, getAdminIntroduceMenuById, updateIntroduceMenu } from 'apis/adminIntroduce';
import {
    useActiveLanguagesQuery,
    useAdminCreateMutation,
    useAdminDetailQuery,
    useAdminUpdateMutation,
} from 'hooks';
import '../../../styles/admin-shared.scss';

const IntroduceMenusForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const toast = useToast();
    const [activeTab, setActiveTab] = useState(0);
    const [formData, setFormData] = useState({ sortOrder: 0, isActive: true, translation: [] });

    const { data: languages = [] } = useActiveLanguagesQuery();
    const { data: detail, error: detailError } = useAdminDetailQuery('introduce-menus', id, getAdminIntroduceMenuById);
    const createMutation = useAdminCreateMutation('introduce-menus', createIntroduceMenu);
    const updateMutation = useAdminUpdateMutation('introduce-menus', updateIntroduceMenu);
    const loading = createMutation.isPending || updateMutation.isPending;

    useEffect(() => {
        if (!id && languages.length) setFormData(prev => ({ ...prev, translation: languages.map(l => ({ languageId: l.id, name: '', slug: '' })) }));
    }, [id, languages]);

    useEffect(() => {
        if (detail) setFormData(detail);
    }, [detail]);

    useEffect(() => {
        if (detailError) toast.error(detailError.message || 'Tải dữ liệu thất bại');
    }, [detailError, toast]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleTranslationChange = (langId, field, value) => {
        setFormData(prev => ({ ...prev, translation: prev.translation.map(t => t.languageId === langId ? { ...t, [field]: value } : t) }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = { ...formData, sortOrder: Number(formData.sortOrder) };
            const res = id
                ? await updateMutation.mutateAsync({ id, data: payload })
                : await createMutation.mutateAsync(payload);
            if (res.success) { toast.success(id ? 'Cập nhật thành công' : 'Thêm mới thành công'); navigate('/admin/introduce-menus'); }
            else toast.error(res.message || 'Lưu thất bại');
        } catch { toast.error('Lưu thất bại'); }
    };

    return (
        <div className="admin-page">
            <PageHeader title={id ? 'Cập nhật Menu Giới thiệu' : 'Thêm Menu Giới thiệu'} />
            <form className="form-card" onSubmit={handleSubmit}>
                <p className="form-section-title">Cài đặt</p>
                <div className="form-row"><Input label="Thứ tự sắp xếp" name="sortOrder" type="number" value={formData.sortOrder} onChange={handleChange} /></div>
                <Checkbox label="Hoạt động" name="isActive" checked={formData.isActive} onChange={handleChange} />
                {languages.length > 0 && (
                    <>
                        <p className="form-section-title">Bản dịch</p>
                        <div className="translation-tabs">
                            <div className="tab-header">{languages.map((lang, i) => <button key={lang.id} type="button" className={`tab-btn ${activeTab === i ? 'active' : ''}`} onClick={() => setActiveTab(i)}>{lang.name}</button>)}</div>
                            {languages.map((lang, i) => {
                                const t = formData.translation.find(t => t.languageId === lang.id) || {};
                                return activeTab === i ? (
                                    <div key={lang.id} className="tab-content">
                                        <Input label="Tên menu *" value={t.name || ''} onChange={e => handleTranslationChange(lang.id, 'name', e.target.value)} required />
                                        <Input label="Slug" value={t.slug || ''} onChange={e => handleTranslationChange(lang.id, 'slug', e.target.value)} />
                                    </div>
                                ) : null;
                            })}
                        </div>
                    </>
                )}
                <div className="form-actions">
                    <Button type="submit" disabled={loading}>{loading ? 'Đang lưu...' : id ? 'Cập nhật' : 'Thêm mới'}</Button>
                    <Button type="button" variant="secondary" onClick={() => navigate('/admin/introduce-menus')}>Hủy</Button>
                </div>
            </form>
        </div>
    );
};

export default IntroduceMenusForm;
